import * as actions from './actionTypes';

export const increasePdpHistory = (contentId) => ({
  type: actions.INCREASE_PDP_HISTORY,
  payload: contentId,
});

export const decreasePdpHistory = (contentId) => ({
  type: actions.DECREASE_PDP_HISTORY,
  payload: contentId,
});

export const resetPdpHistory = () => ({
  type: actions.RESET_PDP_HISTORY,
});

export const increaseBackButtonHistory = () => ({
  type: actions.INCREASE_BACK_BUTTON_HISTORY,
});

export const resetBackButtonHistory = () => ({
  type: actions.RESET_BACK_BUTTON_HISTORY,
});
